export const merchandiseDuty = (htsus = "") => ({
  merchandiseDutyId: "",
  hsDataDtl: {
    pgaRuling: [],
  },
  isCommodityDuty: 2,
  htsus: htsus,
  manifestQuantity: {
    quantity: (0).toFixed(2),
    units: "KG",
  },
  additionalQuantity: {
    quantity: (0).toFixed(2),
    units: (0).toFixed(2),
  },
  enteredValue: (0).toFixed(2),
  duty: (0).toFixed(2),
  otherFee: (0).toFixed(2),
  mpf: {
    rate: (0).toFixed(2),
    fee: (0).toFixed(2),
  },
  hmf: {
    rate: (0).toFixed(2),
    fee: (0).toFixed(2),
  },
  IRTax: (0).toFixed(2),
  irInfo: {},
  dutyRate: (0).toFixed(2),
  charges: (0).toFixed(2),
});

export const invoiceItemData = () => ({
  invoiceId: "",
  vendorId: "",
  vendorName: "",
  addressInfo: [],
  manufacturerId: "",
  manufacturerStatus: "waived",
  deliveryPartyStatus: "WAIVED",
  manufacturerName: "",
  mfgAddressInfo: [],
  invoiceNo: "",
  invoiceDate: {
    epochs: new Date().getTime(),
  },
  poNo: "",
  directShipmentDate: {
    epochs: new Date().getTime(),
  },
  countryOfOrigin: "",
  tariffTreatment: "",
  countryOfExport: "",
  countryOfTranShipment: "",
  grossWeight: {
    qty: -999,
    uom: "",
  },
  netWeight: {
    qty: "",
    uom: "",
  },
  totalUnit: {
    qty: -999,
    uom: "",
  },
  package: {
    qty: "",
    uom: "",
  },
  exchangeRate: "",
  freight: "",
  timeLimit: "",
  cfiaPGADetails:buildInitialCFIAPGAElements()
});


const buildInitialCFIAPGAElements = () =>{

  let pgaDetails = {
    pga:{cbsaPgaType: "CFIA", cbsaPgaSubProgramType: "All Programs"},
    elements:[
      {elementName: "deliveryPartyIdentifier", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyName", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyStreet", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyCity", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyProvince", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyPostalCode", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyCountryCode", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyContactName", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyTelephone", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyFax", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyEmail", uiVals: [{id: "0"}]}
    ]
  }

  return pgaDetails

}
// Provides a base line time object
export const merchandiseLineItem = () => ({
  invoiceId: 0,
  description: "", // string,
  merchandiseId: "",
  merchandiseDutyId: "",
  manufacturerId: "",
  manufacturerName: "",
  mfgAddressInfo: [],
  weight: {
    type: "kg",
    value: "", //Int ...7
  },
  specialAuthority: "", // String ...16
  classificationNo: "", // String 16
  countryOfOrigin: "",
  tariffTreatment: "",
  hsQty: "",
  hsUOM: "",
  manufacturerStatus: "",
  partNo: "",
  specialAuthority: "",
  tariffCode: "", // Int 4
  quantity: "", // double ..11 3r
  unitOfMeasurement: "", // int ...7 5r
  vfdCode: 13, // int ...3
  simaCode: "", //int ...2
  unitPrice: "",
  sku: "",
  total: "",
  rateOfExchange: "",
  rateOfDuty: "",
  rateOfDutyResponse: "",
  specialDutyRate:"0", // double ...7 5r
  rateOfExcise: "", // double ...7 5r
  rateOfGst: 0, // double ...4 2r
  currencyConversionVal: "", // double ...14 2r
  valueForDuty: "", // double ...11 2r
  customsDuties: "", // double ...10 2r
  simaAssessment: "", // double ...11 2r
  exciseTax: "", // double ...10 2r
  valueForTax: "", // double ...12 2r
  gst: "", // double ...11 2r
  simaMeasureInForceCode: "_BALNK_",
  itemInvoicePrice:"",
  incoTerms:"_BLANK_",
  itemInvoicePriceCurrency:"",
  simaQuantity:"",
  simaQuantityType:"",
  simaUOM:"",
  dateOfSale:{},
  security:"",
  exporterId:"",
  modelId:"",
  exportPriceDeduction:"",
  exportPriceDeductionCurrency:"",
  simaSubjectCode:"_BLANK_",
  normalValue:"",
  normalValueCurrency:"",
  simaApplicableFlag:"",
  measureType:"",
  normalValueCAD:"",
  exportPriceCAD:"",
  antiDumpingRate:"",
  antiDumpingDutyAmountAccessed:"",
  antiDumpingRelievedAmount:"",
  antiDumpingDutyNetAmount:"",
  countervailingDutyAmountAccessed:"",
  countervailingDutyRelievedAmount:"",
  countervailingDutyNetAmount:"",
  exportSubsidyRate:"", 
  subsidyRate:"", 
  normalValueUOM:"",
  surtaxSubjectCode:"_BLANK_",
  surtaxMeasureCode:"",
  surtaxAssessedAmount:"",
  surtaxRelievedAmount:"",
  surtaxNetAmount:"",
  safeguardSubjectCode:"_BLANK_",
  safeguardMeasureApplicableFlag:"",
  safeguardMeasureCode:"",
  safeguardAssessedAmount:"",
  safeguardRelievedAmount:"",
  safeguardNetAmount:"",
  exciseRate:""
});

export const initialValues = () => {
  return {
    transactionNo: "",
    LvsData: "",
    requestId: "",
    importer: {
      importer: {
        importerNo: "",
        name: "",
        addressInfo: {
          STREET_NAME: "",
          CITY: "",
          COUNTRY_SUB_ENTITY: "",
          COUNTRY_CODE: "",
          POSTAL_CODE: "",
          COUNTRY: "",
        },
        importerId: "",
      },
    },
    subHrd: {
      subHeaderNo: "",
    },
    declaration: {
      accepted: 2,
    },
    descriptionOfInvoice: {
      invoices: [invoiceItemData()],
    },
    descriptionOfMerchandise: {
      merchandiseLineItems: [merchandiseLineItem()],
    },
    laceyAct: {
      commercialDesc: "",
      charDesc: "",
      PGAItemList: [],
      containers: [
        {
          containerid: "",
          containerNumber: "",
          desccode: "",
          alphaprefix: "",
          checkdigit: "",
        },
      ],
      individualName: "",
      telNumber: "",
      email: "",
      entityAddress1: "",
      entityAddress2: "",
      aptOrSuiteNo: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      declarationCert: false,
      dateOfSign: null,
    },
    cargoInfo: {},
    totals: {
      customsDuties: "",
      simaAssessment: "",
      exciseTax: "",
      gst: "",
      grandTotal: "",
    },
    fieldValidations: {},
  };
};

export const getInitialLaceyAct = () => ({
  commercialDesc: "",
  charDesc: "",
  PGAItemList: [],
  containers: [],
  individualName: "",
  telNumber: "",
  email: "",
  entityAddress1: "",
  entityAddress2: "",
  aptOrSuiteNo: "",
  city: "",
  state: "",
  zip: "",
  country: "",
  declarationCert: false,
  dateOfSign: 0,
});

export const getInitialTSCA = () => ({
  declarationCert: false,
  dateOfSign: 0,
  disclaimCode: 2,
  declarationCode: 2,
});

export const getInitialFDA = () => ({
  commercialDesc: "",
  dateOfSign: 0,
  disclaimCode: 2,
});

export const getNewPGAItem = (index = 1) => ({
  genusName: {
    key: "genusName" + "." + index,
    value: "",
    dataType: "STRING",
    isOptional: "N",
    uiLabel: "Genus Name",
    uiInputType: "DISPLAY",
    uiLabelDesc: "Genus Name",
    PGAId: "genusName",
    isRepeated: "Y",
  },
  speciesName: {
    key: "speciesName" + "." + index,
    value: "",
    dataType: "STRING",
    isOptional: "N",
    uiLabel: "Species Name",
    uiInputType: "DISPLAY",
    uiLabelDesc: "Species Name",
    PGAId: "speciesName",
    isRepeated: "Y",
  },
  countryCode: {
    key: "countryCode" + "." + index,
    value: "",
    dataType: "STRING",
    isOptional: "N",
    uiLabel: "Country Code",
    uiInputType: "DISPLAY",
    uiLabelDesc: "Country Code",
    PGAId: "countryCode",
    isRepeated: "Y",
  },
  indgredientQuantity: {
    key: "indgredientQuantity" + "." + index,
    value: "",
    dataType: "STRING",
    isOptional: "N",
    uiLabel: "Ingredient Quantity",
    uiInputType: "DISPLAY",
    uiLabelDesc: "Ingredient Quantity",
    PGAId: "indgredientQuantity",
    isRepeated: "Y",
  },
  indgredientName: {
    key: "indgredientName" + "." + index,
    value: "",
    dataType: "STRING",
    isOptional: "N",
    uiLabel: "Ingredient Name",
    uiInputType: "DISPLAY",
    uiLabelDesc: "Ingredient Name",
    PGAId: "indgredientName",
    isRepeated: "Y",
  },
  indgredientUom: {
    key: "indgredientUom" + "." + index,
    value: "",
    dataType: "STRING",
    isOptional: "N",
    uiLabel: "Ingredient Uom",
    uiInputType: "DISPLAY",
    uiLabelDesc: "Ingredient Uom",
    PGAId: "indgredientUom",
    isRepeated: "Y",
  },
});

export const manufacturer = () => ({
  headerPartyType: "MANUFACTURER",
  name: "",
  addressInfo: {
    STREET_NAME: [],
    CITY: "",
    COUNTRY_SUB_ENTITY: "",
    POSTAL_CODE: "",
    COUNTRY: "",
  },
  headerId: "",
});

export const getInitialTC = () => ({
  pga: {
    cbsaPgaType: "TC",
    cbsaPgaSubProgramType: "",
  },
  elements: [
    {
      elementName: "tireClass",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "tireClass",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "countryOfOrigin",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "vehicleClass",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "vehicleCondition",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "vehicleIdentificationNumber",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "odometerReading",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "titleStatus",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "vehicleMake",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "vehicleModel",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "showChassisFields",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "vehicleYear",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "productionDate",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "productionDateIntial",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "chassisInfoCode",
      uiVals: [
        { id: 0, value: "" },
        { id: 1, value: "" },
        { id: 2, value: "" },
        { id: 3, value: "" },
      ],
    },
    {
      elementName: "CAppendixFCheckBox",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "chassisInfoDetails",
      uiVals: [
        { id: 0, value: "" },
        { id: 1, value: "" },
        { id: 2, value: "" },
        { id: 3, value: "" },
      ],
    },
    {
      elementName: "finalStageAssemblerIdentification",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "finalStageAssemblerName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "finalStageAssemblerStreet",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "finalStageAssemblerCity",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "finalStageAssemblerProvince",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "finalStageAssemblerPostalCode",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "lpcoDocType",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "lpcoReference",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "imageURN",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "vehicleStatus",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "finalStageAssemblerCountryCode",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "criteriaConformance",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "affirmationOfStmtOfCompliance",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "tcType",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "tireType",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "tireSize",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "unitSizeInEach",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "reasonForImport",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "brandName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "manufacturerName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "manufacturerStreet",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "manufacturerCity",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "manufacturerProvince",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "manufacturerPostalCode",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "manufacturerCountryCode",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "complianceNonUsNewTires",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "complianceUsNewTires",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "complianceNonUsUsedTires",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "complianceUsUsedTires",
      uiVals: [{ id: 0, value: "" }],
    },
  ],
});

export const getInitialECCC = (pType) => ({
  pga: {
    cbsaPgaType: "ECCC",
    cbsaPgaSubProgramType: pType,
  },
  elements: [
    {
      elementName: "engineManufacturerName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "veClass",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "engineIdentificationNumber",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "veTestGroup",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "veIdentificationNumber",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "machineModelYear",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "engineMake",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "engineModel",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "engineModelYear",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "machineModelName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "machineMake",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "engineFamilyName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "engineClass",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "complianceNationalEmissionsMark",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "complianceEPACertified",
      value: "",
    },
    {
      elementName: "complianceCanadaUsTransition",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "complianceCanadaUnique",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "complianceCanadaIncomplete",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "veProgramExceptionProcess",
      uiVals: [{ id: 0, value: "" }],
    },
  ],
});
export const getInitialECCC1 = () => ({
  pga: {
    cbsaPgaType: "ECCC",
    cbsaPgaSubProgramType: "Wildlife Enforcement",
  },
  elements: [
    {
      elementName: "commonName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "showCompleteForm",
      uiVals: [
        {
          id: 0,
          value: "false",
        },
      ],
    },
    {
      elementName: "scientificName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "age",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "sex",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "lifeStage",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "intendedUsePurpose",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "identificationNumberType",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "identificationNumber",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "commodityIdentifierType",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "commodityIdentifier",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "sourceOfSpecimen",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "countryOfSource",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "lpcoNum",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "wlIssueDate",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "wlExpDate",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeStreet",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeCity",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeProvince",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteePostalCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeCountryCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeContactName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeTelephone",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeFax",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "permitteeEmail",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "lpcoReference",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "imageURN",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "lpcoDocType",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "ecccRegulatedGoods",
      uiVals: [
        {
          id: 0,
          value: "EC17",
        },
      ],
    },
    {
      elementName: "importerBusinessNumber",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "importerContactName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "importerTelephone",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterStreet",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterCity",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterProvince",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterTelephone",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterEmail",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterIdentification",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterPostalCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterCountryCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterContactName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "importerEmail",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
  ],
});

export const getInitialInvoiceECCC = () => ({
  pga: {
    cbsaPgaType: "ECCC",
    cbsaPgaSubProgramType: "Wildlife Enforcement",
  },
  elements: [
    {
      elementName: "disclaimCode",
      value: "N",
    },
    {
      elementName: "vendorIdentification",
      value: "",
    },
    {
      elementName: "vendorName",
      value: "",
    },
    {
      elementName: "vendorStreet",
      value: "",
    },
    {
      elementName: "vendorCity",
      value: "",
    },
    {
      elementName: "vendorProvince",
      value: "",
    },
    {
      elementName: "vendorPostalCode",
      value: "",
    },
    {
      elementName: "vendorCountryCode",
      value: "",
    },
    {
      elementName: "vendorContactName",
      value: "",
    },
    {
      elementName: "vendorTelephone",
      value: "",
    },
    {
      elementName: "vendorEmail",
      value: "",
    },
    {
      elementName: "vendorFax",
      value: "",
    },
    {
      elementName: "exporterIdentification",
      value: "",
    },
    {
      elementName: "exporterName",
      value: "",
    },
    {
      elementName: "exporterStreet",
      value: "",
    },
    {
      elementName: "exporterCity",
      value: "",
    },
    {
      elementName: "exporterProvince",
      value: "",
    },
    {
      elementName: "exporterPostalCode",
      value: "",
    },
    {
      elementName: "exporterCountryCode",
      value: "",
    },
    {
      elementName: "exporterContactName",
      value: "",
    },
    {
      elementName: "exporterTelephone",
      value: "",
    },
    {
      elementName: "exporterEmail",
      value: "",
    },
    {
      elementName: "exporterFax",
      value: "",
    },
  ],
});
export const getInitialCNSC = () => ({
  pga: {
    cbsaPgaType: "CNSC",
    cbsaPgaSubProgramType: "Import Control",
  },
  elements: [
    {
      elementName: "undgCNSC",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "regulateCNSC",
      uiVals: [
        {
          id: 0,
          value: "false",
        },
      ],
    },
    {
      elementName: "showfullFormCNSC",
      uiVals: [
        {
          id: 0,
          value: "false",
        },
      ],
    },
    {
      elementName: "chemspec",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "radQty",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "itemWt",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },{
      elementName: "itemWtUoM",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "radUnit",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "dpIdentification",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "dpName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "dpStreet",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "dpCity",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "dpProvince",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "dpPostalCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "dpCountryCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "lpcoDocType",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "lpcoNum",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "imageURN",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "apIdentification",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "apName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "apStreet",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "apCity",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "apProvince",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "apPostalCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "apCountryCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "pkgQty",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "pkgLvlCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "pkgDescCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "pkgCert",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterIdentification",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterName",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterStreet",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterCity",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterProvince",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterPostalCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
    {
      elementName: "exporterCountryCode",
      uiVals: [
        {
          id: 0,
          value: "",
        },
      ],
    },
  ],
});

export const getInitialCFIA = () => ({
  pga: {
    cbsaPgaType: "CFIA",
    cbsaPgaSubProgramType: "All Programs",
  },
  elements: [
    {
      elementName: "deliveryPartyIdentifier",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "accountPayerInfoRequired",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyStreet",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyCity",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyProvince",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyPostalCode",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyCountryCode",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyContactName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyTelephone",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyFax",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "deliveryPartyEmail",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "countryOfSource",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "stateOfSource",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "airsExtensionCode",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "airsEndUse",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "airsMiscellaneous",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "airsRegistrationType",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "airsRegistrationNumber",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "lpcoReference",
      uiVals: [{ id: 0, value: "", uiFieldName: "dematerialized" }],
    },
    {
      elementName: "imageURN",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "cfiaSubmit",
      uiVals: [{ id: 0, value: "false" }],
    },
    {
      elementName: "lpcoDocType",
      uiVals: [{ id: 0, value: "", uiFieldName: "dematerialized" }],
    },
  ],
});
export const getInitialCFIAPayor = () => ({
  pga: {
    cbsaPgaType: "CFIA",
    cbsaPgaSubProgramType: "All Programs",
  },
  elements: [
    {
      elementName: "cfiaAccountNumber",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "cfiaPayerName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "cfiaPayerStreet",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "cfiaPayerProvince",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "cfiaPayerPostalCode",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "cfiaPayerCountryCode",
      uiVals: [{ id: 0, value: "" }],
    },
  ],
});

export const getInitialNRCan = () => ({
  pga: {
    cbsaPgaType: "NRCan",
    cbsaPgaSubProgramType: "Office of Energy Efficiency",
  },
  elements: [
    {
      elementName: "tradeName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "brandName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "modelName",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "intendedUsePurpose",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "commodityType",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "countryOfOrigin",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "stateOfOrigin",
      uiVals: [{ id: 0, value: "" }],
    },
  ],
});
export const getInitialGAC = () => ({
  pga: {
    cbsaPgaType: "GAC",
    cbsaPgaSubProgramType: "Steel",
  },
  elements: [
    {
      elementName: "gacLpcoDocType",
      uiVals: [{ id: 0, value: "2006" }],
    },
    {
      elementName: "gacLpcoReference",
      uiVals: [{ id: 0, value: "" }],
    },
    {
      elementName: "gacCountryOfMeltAndPour",
      uiVals: [{ id: 0, value: "" }],
    },
  ],
});
